import { Add, Delete } from "@mui/icons-material";
import { Button, IconButton, List, ListItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { v4 as uuid } from "uuid";

import { GqlPermissions, GqlProtocolVisit } from "~/__generated__";
import useHasTenantPermission from "~/modules/auth/hooks/useHasPermission";

import { ProtocolVisitCondition, VisitConditionAnd, VisitConditionOr } from "../../types/ProtocolVisitCondition";
import ProtocolVisitConditionsEditor from ".";

type Props = {
    allVisits: GqlProtocolVisit[];
    logicalCondition: VisitConditionAnd | VisitConditionOr;
    onChange: (condition?: ProtocolVisitCondition) => void;
};

export default function ConditionEditorLogical({ allVisits, logicalCondition, onChange }: Props) {
    const isAdmin = useHasTenantPermission(GqlPermissions.Administrator);
    const { t } = useTranslation("protocol");
    return (
        <List sx={{ p: 0, ml: 1, md: { ml: 6 } }}>
            {logicalCondition.conditions?.map(condition => (
                <ListItem key={condition.id} sx={{ p: 0, my: 1, alignItems: "start" }}>
                    <ProtocolVisitConditionsEditor
                        sx={{ flex: 1 }}
                        allVisits={allVisits}
                        condition={condition}
                        onChange={update => {
                            if (!update) return;
                            onChange({
                                ...logicalCondition,
                                conditions: logicalCondition.conditions?.map(c => (c.id == condition?.id ? update : c)),
                            });
                        }}
                    />
                    {isAdmin && (
                        <IconButton
                            size="large"
                            onClick={() => {
                                onChange({
                                    ...logicalCondition,
                                    conditions: logicalCondition.conditions?.filter(c => c.id != condition.id),
                                });
                            }}
                        >
                            <Delete />
                        </IconButton>
                    )}
                </ListItem>
            ))}
            {isAdmin && (
                <ListItem sx={{ justifyContent: "center" }}>
                    <Button
                        fullWidth
                        startIcon={<Add />}
                        onClick={() => {
                            onChange({
                                ...logicalCondition,
                                conditions: [...(logicalCondition.conditions ?? []), { type: "minDate", id: uuid() }],
                            });
                        }}
                    >
                        {t("protocolVisitConditionsEditor.btnAddCondition")}
                    </Button>
                </ListItem>
            )}
        </List>
    );
}
